import script from "./OurLossPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OurLossPage.vue?vue&type=script&setup=true&lang=js"

import "./OurLossPage.vue?vue&type=style&index=0&id=10f777c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f777c7"]])

export default __exports__